import { forwardRef, HTMLAttributes } from "react";

export type Props = HTMLAttributes<HTMLSpanElement> & {
  /** Whether to render the dot. False renders nothing. */
  hasUnread: boolean;
  className?: string;
  "data-testid"?: string;
};

/**
 * Base presence-only unread indicator with no styling.
 * Renders nothing when `hasUnread` is false; otherwise an empty span
 * intended to be styled (typically as a small filled circle) by the
 * theme layer. Marked aria-hidden because it carries no information
 * not already available via the parent control's text or unread count.
 */
export const UnreadDotBase = forwardRef<HTMLSpanElement, Props>(
  ({ hasUnread, className, "data-testid": testId = "unread-dot-base", ...props }, ref) => {
    if (!hasUnread) return null;

    return (
      <span
        ref={ref}
        className={className}
        data-testid={testId}
        aria-hidden="true"
        {...props}
      />
    );
  }
);

UnreadDotBase.displayName = "UnreadDotBase";
